import { useSelector } from 'react-redux';
import { defineMessages } from 'react-intl';
import * as actions from '../../../../state';
import {
  axisGroup,
  extraGroup,
  lineGroup,
} from './lineControlLists';

const messages = defineMessages({
  LINES: {
    id: 'LINES',
    defaultMessage: 'Lines',
  },
  AXIS: {
    id: 'AXIS',
    defaultMessage: 'Axis, Grid & Legend',
  },
  EXTRA: {
    id: 'EXTRA',
    defaultMessage: 'Extra',
  },
  HIDDEN: {
    id: 'HIDDEN',
    defaultMessage: 'Hidden',
  },
  LABEL_BOTTOM: {
    id: 'LABEL_BOTTOM',
    defaultMessage: 'Label Bottom',
  },
  SHAPE: {
    id: 'SHAPE',
    defaultMessage: 'Shape',
  },
  COLORS: {
    id: 'COLORS',
    defaultMessage: 'Color',
  },
  DOT_SIZE: {
    id: 'DOT_SIZE',
    defaultMessage: 'Dot Size',
  },
  DOT_BORDER_WIDTH: {
    id: 'DOT_BORDER_WIDTH',
    defaultMessage: 'Dot Border Width',
  },
  ENABLE_DOT_LABEL: {
    id: 'ENABLE_DOT_LABEL',
    defaultMessage: 'Enable Dot Labels',
  },
  ENABLE_AXIS_LABEL_Y: {
    id: 'ENABLE_AXIS_LABEL_Y',
    defaultMessage: 'Enable Axis Label (units)',
  },
  ENABLE_GRID_X: {
    id: 'ENABLE_GRID_X',
    defaultMessage: 'Enable Grid X',
  },
  ENABLE_GRID_Y: {
    id: 'ENABLE_GRID_Y',
    defaultMessage: 'Enable Grid Y',
  },
  ENABLE_LEGEND: {
    id: 'ENABLE_LEGEND',
    defaultMessage: 'Enable Legend',
  },
  LEGEND_WIDTH: {
    id: 'LEGEND_WIDTH',
    defaultMessage: 'Legend Width',
  },
  STACK_LINES: {
    id: 'STACK_LINES',
    defaultMessage: 'Stack Line Values',
  },
  LINE_WIDTH: {
    id: 'LINE_WIDTH',
    defaultMessage: 'Line Width',
  },
  AREA_OPACITY: {
    id: 'AREA_OPACITY',
    defaultMessage: 'Area Opacity',
  },
  TICK_BOTTOM_DENSITY: {
    id: 'TICK_BOTTOM_DENSITY',
    defaultMessage: 'X-Axis Density',
  },
  TICK_LEFT_DENSITY: {
    id: 'TICK_LEFT_DENSITY',
    defaultMessage: 'Y-Axis Density',
  },
  TICK_STEP: {
    id: 'TICK_STEP',
    defaultMessage: 'Tick Step',
  },
  TICK_TYPE: {
    id: 'TICK_TYPE',
    defaultMessage: 'Tick Type',
  },
  LABEL_FONT_SIZE: {
    id: 'LABEL_FONT_SIZE',
    defaultMessage: 'Label Font Size',
  },
  GRID_OPACITY: {
    id: 'GRID_OPACITY',
    defaultMessage: 'Grid Opacity',
  },
  MARGIN_BOTTOM: {
    id: 'MARGIN_BOTTOM',
    defaultMessage: 'Margin Bottom',
  },
  MARGIN_TOP: {
    id: 'MARGIN_TOP',
    defaultMessage: 'Margin Top',
  },
  MARGIN_LEFT: {
    id: 'MARGIN_LEFT',
    defaultMessage: 'Margin Left',
  },
  MARGIN_RIGHT: {
    id: 'MARGIN_RIGHT',
    defaultMessage: 'Margin Right',
  },
  LINEAR: {
    id: 'LINEAR',
    defaultMessage: 'Linear',
  },
  CURVED: {
    id: 'CURVED',
    defaultMessage: 'Curved',
  },
  STEP: {
    id: 'STEP',
    defaultMessage: 'Step',
  },
});

function LineStyleControls({ renderControlGroup }) {
  const extraStyleControls = useSelector((state) => actions.selectConfig(state, 'ANALYTICS_EXTRA_STYLE_CONTROLS'));

  // controls by group, used to present controls in like groups
  const controlsGroups = [{
    labelId: 'LINES',
    controls: lineGroup,
  }, {
    labelId: 'AXIS',
    controls: axisGroup,
  }];

  if (extraStyleControls) {
    controlsGroups.push({
      labelId: 'EXTRA',
      controls: extraGroup,
    });
  }

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

export default LineStyleControls;
